import MarkdownToJsx from 'markdown-to-jsx';
import PropTypes from 'prop-types';

import Anchor from './typography/anchor';

const options = { overrides: { a: { component: Anchor } } };

const Markdown = ({ children, className }) => {
  return (
    <MarkdownToJsx className={className} options={options}>
      {children}
    </MarkdownToJsx>
  );
};

Markdown.propTypes = {
  children: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default Markdown;
